import { Component, OnInit, OnDestroy, ViewChild, EventEmitter, Output } from '@angular/core';
import { Store } from '@ngrx/store';
import { Subject, Observable } from 'rxjs';
import * as _ from 'underscore';
import { RootStoreState } from 'src/app/root-store';

import { getDesignError, getDesignLoading, getProject, getProjectError, getProjectList, getProjectListError, getProjectListLoading, getProjectLoading } from 'src/app/root-store/kwikspace-app-store/selectors/floorplanner.selector';
import { GetProject, GetProjectList } from 'src/app/root-store/kwikspace-app-store/actions/floorplanner.action';
import { takeUntil } from 'rxjs/operators';
import { FloorplannerDesign, FloorplannerProject } from 'src/app/models/Floorplanner.model';
import { ModalComponent } from 'src/app/core/components/modal/modal.component';

@Component({
  selector: 'app-existing-diagram',
  templateUrl: './existing-diagram.component.html',
  styleUrls: ['./existing-diagram.component.scss']
})
export class ExistingDiagramComponent implements OnInit, OnDestroy {
  private ngUnsubscribe = new Subject();

  @ViewChild("floorplannerViewProjectModal", { static: false })
  floorplannerViewProjectModal: ModalComponent;

  @ViewChild("floorplannerViewDesignModal", { static: false })
  floorplannerViewDesignModal: ModalComponent;

  projectListLoading$: Observable<any> = this.store.select(getProjectListLoading);
  projectListError$: Observable<any> = this.store.select(getProjectListError);

  projectLoading$: Observable<any> = this.store.select(getProjectLoading);
  projectError$: Observable<any> = this.store.select(getProjectError);

  designLoading$: Observable<any> = this.store.select(getDesignLoading);
  designError$: Observable<any> = this.store.select(getDesignError);

  designs: FloorplannerDesign[] = [];
  designSelected: boolean = false;
  designIDSelected: number = null;
  selectedDesignThumbnail: string = null;

  projects: FloorplannerProject[] = [];
  projectSelected: boolean = false;
  projectIDSelected: number = null;
  selectedProjectThumbnail: string = null;
  selectedProjectThumbnail3d: string = null;
  currentProject = null;

  selectedFloorId: number = null;

  @Output() onProjectSelect = new EventEmitter<any>();

  constructor(
    private store: Store<RootStoreState.RootState>,
  ) { }

  ngOnInit() {
    this.store.dispatch(new GetProjectList());

    this.store
      .select(getProjectList)
      .pipe(takeUntil(this.ngUnsubscribe))
      .subscribe((res: any) => {
        if (res && res.results) {
          this.projects = res.results.length > 0 ? res.results : [];
        }
      });


  }

  setSelectedProject(project) {
    this.projectIDSelected = project.floorplannerProjectId;
    this.projectSelected = true;

    this.getProject();
  }

  getProject() {
    this.store.dispatch(new GetProject(this.projectIDSelected));

    this.store
      .select(getProject)
      .pipe(takeUntil(this.ngUnsubscribe))
      .subscribe(res => {
        if (res) {
          this.currentProject = res;
          if (res.floors) {
            this.selectedFloorId = res.floors[0].id;
            this.designs = res.floors[0].designs;
          }
        }
      });
  }

  viewSelectedProject(project) {
    this.selectedProjectThumbnail = project.thumbnail;
    this.selectedProjectThumbnail3d = project.thumbnail3d;

    this.floorplannerViewProjectModal.open();
  }

  setSelectedDesign(design) {
    this.designIDSelected = design.id;
    this.designSelected = true;

    let selectedOptions = {
      type: 'existing',
      project: this.currentProject,
      projectId: this.projectIDSelected,
      floorId: this.selectedFloorId,
      design,
      designId: this.designIDSelected
    }

    this.onProjectSelect.emit(selectedOptions);
  }

  viewSelectedDesign(design) {
    let selectedDesign = this.designs.filter(designItem => designItem.id === design.id)
    this.selectedDesignThumbnail = selectedDesign[0].thumbUrl;

    this.floorplannerViewDesignModal.open();
  }

  ngOnDestroy() {
    this.ngUnsubscribe.next();
    this.ngUnsubscribe.complete();
  }
}